import { setAppSpinning, showNotification } from 'app/appSlice'
import CancelInvoiceModal from 'general/components/Modal/CancelInvoiceModal'
// import FindInvoiceModal from 'general/components/Modal/FindInvoiceModal'
import { List, Space, Tooltip } from 'antd'
import invoiceApi from 'api/invoiceApi'
import dayjs from 'dayjs'
import {
  setClearRows,
  setModalsState,
  setSelectedInvoices,
} from 'features/Invoice/invoiceSlice'
import ModalConvertPaper from 'features/Search/components/ModalConvertPaper'
import AppDnD from 'general/components/AppDragAndDrop/AppDnD'
import CustomAntButton from 'general/components/Button/CustomAntButton'
import ContentContainer from 'general/components/ContentContainer'
import CustomDataTable from 'general/components/CustomDataTable'
import FilterPopover from 'general/components/CustomPopover/FilterPopover'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import { IconAction } from 'general/components/GroupButton/styles'
import TableAction from 'general/components/GroupButton/TableAction'
import ExplanationInvoiceModal from 'general/components/Modal/ExplanationInvoiceModal'
import ModalConfirm from 'general/components/Modal/ModalConfirm'
import ModalSelectAdjustInvoiceMethod from 'general/components/Modal/ModalSelectAdjustInvoiceMethod'
import ModalSendEmail from 'general/components/Modal/ModalSendEmail'
import ModalUnauthorized from 'general/components/Modal/ModalUnauthorized'
import ModalUploadInvoiceExcel from 'general/components/Modal/ModalUploadInvoiceExcel'
import SendInvoiceModal from 'general/components/Modal/SendInvoiceModal'
import ModalDataTransmissionLog from 'general/components/ModalDataTransmissionLog'
import {
  INVOICE_STATUS,
  INVOICE_TYPE,
  MESSAGE_SUCCESS,
} from 'general/constants/AppConstants'
import PreferenceKeys from 'general/constants/PreferenceKeys'
import SelectOptions from 'general/constants/SelectOptions'
import InvoiceHelper from 'general/helpers/InvoiceHelper'
import ToastHelper from 'general/helpers/ToastHelper'
import Utils, { getYearsFromDates, padNumber } from 'general/utils/Utils'
import useGetSerials from 'hooks/Queries/useGetSerials'
import useAppDnD from 'hooks/useAppDnD'
import useFilter from 'hooks/useFilter'
import { useAppDispatch, useAppSelector } from 'hooks/useRedux'
import useRouter from 'hooks/useRouter'
import useSearchDebounce from 'hooks/useSearchDebounce'
import _ from 'lodash'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { shallowEqual } from 'react-redux'
import {
  useMutationBulkInvoicePaidStatus,
  useMutationCancelInvoice,
  useMutationCheckMessage,
  useMutationDeleteInvoice,
  useMutationDownloadInvoice,
  useMutationDownloadPdf,
  useMutationDownloadXml,
  useMutationGetBulkMessage,
  useMutationHsmSigning,
  useMutationInvoicePaidStatus,
  useMutationPrintInvoice,
  useMutationResendIssue,
  useMutationSendExplanationAnnounce,
  useMutationViewPdf,
  useQueryListHistoryInvoiceTax,
  useQueryListInInvoice,
  useQueryListInvoice,
  useQueryListOrganization,
} from '../../../../../Invoice/screens/ListInvoice/queries'
import { useQuery } from '@tanstack/react-query'
import { goodsQueries } from 'features/Category/screens/GoodsScreen/queries'
import ModalSelectReplaceInvoiceMethod from 'general/components/Modal/ModalSelectReplaceInvoiceMethod'
import InvoiceDashboard from 'features/Invoice/screens/ListInvoice/Components/InvoiceDashboard'
import VITableRowDropDown from '../VITableRowDropDown'
import VIButton from 'general/components/eInvoiceComponents/VIButton'
import KTTooltip from 'general/components/eInvoiceComponents/KTTooltip'
import * as Yup from 'yup'
import { FastField, Formik } from 'formik'
import AppConfigs from 'general/constants/AppConfigs'
import AppResource from 'general/constants/AppResource'
import KTFormGroup from 'general/components/Forms/KTFormGroup'
import VIFormCheck from '../VIFormCheck'
import { useSelector } from 'react-redux'
import KTFormInput, {
  KTFormInputType,
} from 'general/components/Forms/KTFormInput'
import { thunkCreateNewOrganization } from 'features/InPutEInvoice/inputEinvoiceSlice'

function AddAccount({
  initialPassword,
  setModalAddAccountShowing,
  refetctProfile = () => {},
  profile,
}) {
  // MARK --- Parmas: ---
  const { t } = useTranslation()
  const { navigate } = useRouter()
  const dispatch = useAppDispatch()
  const { listFunctions, userFunctions } = useAppSelector(
    (state) => state?.function,
    shallowEqual,
  )
  const { activeSigningMethod } = useAppSelector(
    (state) => state.system.company,
  )

  const { company } = useAppSelector((state) => state?.system)
  const { selectedInvoices, toggledClearRows, modalStates } = useAppSelector(
    (state) => state.invoice,
    shallowEqual,
  )

  const { haveCanDownloadInvoice, allCanSignInvoice, allCanDownloadInvoice } =
    useMemo(() => {
      const canDownloadInvoice = selectedInvoices?.some((invoice) => {
        return (
          (invoice.issueStatus === INVOICE_STATUS.AUTHORITY_CODE_GIVEN ||
            invoice.issueStatus === INVOICE_STATUS.AUTHORITY_ACCEPT) &&
          invoice.type !== INVOICE_TYPE.CANCELLED &&
          invoice.type !== INVOICE_TYPE.REPLACED &&
          invoice.type !== INVOICE_TYPE.DELETED
        )
      })
      const canAllSignInvoice = selectedInvoices?.some((invoice) => {
        return [
          INVOICE_STATUS.SEND_ERROR,
          INVOICE_STATUS.SIGN_ERROR,
          INVOICE_STATUS.NOT_SENT_TO_AUTHORITY,
        ].includes(invoice.issueStatus)
      })
      const canAllDownloadInvoice = !selectedInvoices?.some((invoice) => {
        return (
          (invoice.issueStatus !== INVOICE_STATUS.AUTHORITY_CODE_GIVEN &&
            invoice.issueStatus !== INVOICE_STATUS.AUTHORITY_ACCEPT) ||
          invoice.type === INVOICE_TYPE.CANCELLED ||
          invoice.type === INVOICE_TYPE.REPLACED
        )
      })

      return {
        haveCanDownloadInvoice: canDownloadInvoice,
        allCanSignInvoice: canAllSignInvoice,
        allCanDownloadInvoice: canAllDownloadInvoice,
      }
    }, [selectedInvoices])

  const [inInvoiceOn, setInInvoiceOn] = useState(true)
  const [outInvoiceOn, setOutInvoiceOn] = useState(false)
  const [isConnecting, setIsConnecting] = useState(false)

  useEffect(() => {}, [])

  const createNewOrganization = async (body) => {
    const data = await dispatch(thunkCreateNewOrganization(body))
    if (!data?.error) {
      ToastHelper.showSuccess('Thêm tài khoản thành công')
      setModalAddAccountShowing(false)
      refetctProfile()
    }
    console.log('data', data)
    // setProfile(data?.payload?.account ?? {})
  }

  return (
    <ContentContainer.Body>
      <div>
        <Formik
          initialValues={{
            url: AppConfigs.axionConnectUrl,
            username: profile?.Company?.taxCode ?? '',
            password: initialPassword,
          }}
          validationSchema={Yup.object({
            url: Yup.string().required(t('Required')),
            username: Yup.string().required(t('Required')),
            password: Yup.string().required(t('Required')),
          })}
          enableReinitialize
          onSubmit={async (values) => {
            const params = {
              username: values.username,
              password: values.password,
              isInput: inInvoiceOn,
              isOutput: outInvoiceOn,
            }
            console.log('params', params)
            setIsConnecting(true)
            try {
              let data = await createNewOrganization(params)
            } catch (error) {}
            setIsConnecting(false)
          }}
        >
          {(formikProps) => {
            return (
              <div>
                <div
                  className="p-4 gutter-b"
                  style={{
                    backgroundColor: '#F8F8F8',
                    borderRadius: '12px',
                  }}
                >
                  <p className="m-0">
                    Vui lòng đăng nhập bằng tài khoản CQT đã cung cấp cho doanh
                    nghiệp để tự động tra cứu xử lý và tải về hoá đơn theo Nghị
                    định 123/2020/NĐ-CP
                  </p>
                </div>

                <div className="">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="d-flex flex-column align-items-center justify-content-center h-100">
                        <img
                          src={AppResource.images.imgAxionBg}
                          className="w-100"
                          style={{}}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 mt-6 mt-lg-0">
                      {/* link website tra cuu */}
                      <KTFormGroup
                        label={
                          <>
                            {t('LinkToLookupWebsite')}{' '}
                            <span className="text-danger">(*)</span>
                          </>
                        }
                        inputName="url"
                        inputElement={
                          <FastField name="url">
                            {({ field, form, meta }) => (
                              <KTFormInput
                                name={field.name}
                                value={field.value}
                                onChange={(value) => {
                                  form.setFieldValue(field.name, value)
                                }}
                                onBlur={() => {
                                  form.setFieldTouched(field.name, true)
                                }}
                                enableCheckValid
                                isValid={_.isEmpty(meta.error)}
                                isTouched={meta.touched}
                                feedbackText={meta.error}
                                type={KTFormInputType.text}
                                placeholder=""
                                disabled
                              />
                            )}
                          </FastField>
                        }
                      />

                      {/* ten dang nhap */}
                      <KTFormGroup
                        label={
                          <>
                            {t('Username')}{' '}
                            <span className="text-danger">(*)</span>
                          </>
                        }
                        inputName="username"
                        inputElement={
                          <FastField name="username">
                            {({ field, form, meta }) => (
                              <KTFormInput
                                name={field.name}
                                value={field.value}
                                onChange={(value) => {
                                  form.setFieldValue(field.name, value)
                                  // if (!addMoreAccountMode) {
                                  //   AxionHelper.saveUsername(value)
                                  // }
                                  // if (onChangeInputUserName) {
                                  //   onChangeInputUserName(value)
                                  // }
                                }}
                                onBlur={() => {
                                  form.setFieldTouched(field.name, true)
                                }}
                                enableCheckValid
                                isValid={_.isEmpty(meta.error)}
                                isTouched={meta.touched}
                                feedbackText={meta.error}
                                type={KTFormInputType.text}
                                placeholder={`${t('Username')}...`}
                              />
                            )}
                          </FastField>
                        }
                      />

                      {/* mat khau */}
                      <KTFormGroup
                        label={
                          <>
                            {t('Password')}{' '}
                            <span className="text-danger">(*)</span>
                          </>
                        }
                        inputName="password"
                        additionalClassName="mb-0"
                        inputElement={
                          <FastField name="password">
                            {({ field, form, meta }) => (
                              <KTFormInput
                                name={field.name}
                                value={field.value}
                                onChange={(value) => {
                                  form.setFieldValue(field.name, value)
                                  // if (!addMoreAccountMode) {
                                  //   AxionHelper.savePassword(value)
                                  // }
                                  // if (onChangeInputPassword) {
                                  //   onChangeInputPassword(value)
                                  // }
                                }}
                                onBlur={() => {
                                  form.setFieldTouched(field.name, true)
                                }}
                                enableCheckValid
                                isValid={_.isEmpty(meta.error)}
                                isTouched={meta.touched}
                                feedbackText={meta.error}
                                type={KTFormInputType.password}
                                placeholder={`${t('Password')}...`}
                              />
                            )}
                          </FastField>
                        }
                      />
                    </div>
                  </div>

                  <div className="row mt-6">
                    <div className="col-lg-6"></div>

                    <div className="col-lg-6">
                      <p className="font-weight-bolder text-grey mb-0">
                        {t('InvoiceType')}
                      </p>
                      <div className="d-flex flex-wrap align-items-center">
                        <VIFormCheck
                          type="checkbox"
                          id="checkboxInInvoice"
                          name={t('InInvoice')}
                          handleChange={() => {
                            const newValue = !inInvoiceOn
                            setInInvoiceOn(newValue)
                          }}
                          checkedItem={inInvoiceOn}
                          className="mr-6"
                        />
                        {/* <VIFormCheck
                          type="checkbox"
                          id="checkboxOutInvoice"
                          name={t('OutInvoice')}
                          handleChange={() => {
                            const newValue = !outInvoiceOn
                            setOutInvoiceOn(newValue)
                            if (onSwitchChangeOutInvoiceType && newValue) {
                              onSwitchChangeOutInvoiceType(newValue)
                            }
                            if (!newValue) {
                              if (!addMoreAccountMode) {
                                AxionHelper.saveSwitchInvoiceOut(newValue)
                              }
                              if (onChangeOutInvoice) {
                                onChangeOutInvoice(newValue)
                              }
                            }
                          }}
                          checkedItem={outInvoiceOn}
                        /> */}
                      </div>

                      {outInvoiceOn && (
                        <div>
                          <p>
                            Tải toàn bộ hóa đơn đầu ra (bao gồm hóa đơn phát
                            hành bởi ICORP eInvoice{' '}
                            <a
                              href="#"
                              className="font-weight-bold"
                              style={{
                                textDecoration: 'underline',
                              }}
                              onClick={(e) => {
                                e.preventDefault()
                                handlePressChangeInvoiceType()
                              }}
                            >
                              {t('Change')}
                            </a>
                          </p>
                        </div>
                      )}

                      <div
                        className="px-4 py-2 mt-4"
                        style={{
                          backgroundColor: '#F8F8F8',
                          borderRadius: '12px',
                        }}
                      >
                        <p className="m-0">
                          <span className="text-danger">Lưu ý:</span> Mọi hóa
                          đơn lấy về sẽ được tính tài nguyên
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* actions */}
                  <div className="d-flex align-items-center justify-content-end gap-3 mt-6">
                    <VIButton
                      text={t('Cancel')}
                      className="btn-grey"
                      style={{ padding: '8px' }}
                      onClick={() => {
                        setModalAddAccountShowing(false)
                      }}
                    />
                    <VIButton
                      text={
                        isConnecting ? `${t('Connecting')}...` : t('Connect')
                      }
                      className=""
                      style={{ padding: '8px' }}
                      onClick={() => {
                        formikProps.handleSubmit()
                      }}
                      disabled={isConnecting}
                      // beforeIcon={
                      //   isConnecting ? (
                      //     <ClockLoader color="white" size={20} />
                      //   ) : (
                      //     <></>
                      //   )
                      // }
                    />
                  </div>
                </div>
              </div>
            )
          }}
        </Formik>
      </div>
    </ContentContainer.Body>
  )
}

export default AddAccount
